import { createAction } from "../libs/redux/saga";
export const ISLOGGED = "ISLOGGED";
export const FORGOT = "FORGOT";
export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
//---------------------------------
export const DASHBOARD = "DASHBOARD";
export const ROLE = "ROLE";
export const ROLEALL = "ROLEALL";
export const USERROLE = "USERROLE";
export const PERMISSION = "PERMISSION";
export const SETTINGS = "SETTINGS";
export const USER = "USER";
export const USERALL = "USERALL";

export const COMPANY = "COMPANY";
export const COMPANYALL = "COMPANYALL";
export const PROJECT = "PROJECT";
export const PROJECTALL = "PROJECTALL";
export const TIMELAPSE = "TIMELAPSE";
export const TIMELAPSEALL = "TIMELAPSEALL";
export const LIVECAM = "LIVECAM";
export const LIVECAMALL = "LIVECAMALL";
export const PTZ = "PTZ";
export const PTZACTION = "PTZACTION";
export const LIVESETTINGS = "LIVESETTINGS";
export const LIVESETTINGSALL = "LIVESETTINGSALL";
export const PTZACTIONALL = "PTZACTIONALL";
export const PACKAGE = "PACKAGE";
export const PACKAGEALL = "PACKAGEALL";
export const RECIEPT = "RECIEPT";
export const LATESTFILE = "LATESTFILE";
export const BRAND = "BRAND";
export const BRANDALL = "BRANDALL";
export const PRESET = "PRESET";
export const PRESETALL = "PRESETALL";
export const TLVIDEO = "TLVIDEO";
export const TLVIDEOALL = "TLVIDEOALL";
export const IMGARCHIVE = "IMGARCHIVE";
export const IMGARCHIVEALL = "IMGARCHIVEALL";
export const VDOARCHIVE = "VDOARCHIVE";
export const VDOARCHIVEALL = "VDOARCHIVEALL";
export const RECEIPT = "RECEIPT";

export const VIDEO = "VIDEO";
export const VIDEOALL = "VIDEOALL";

export const VIDEOZIP = "VIDEOZIP";
export const VIDEOZIPALL = "VIDEOZIPALL";

export const SENDEMAIL = "SENDEMAIL";

export const DATEDIMAGE = "DATEDIMAGE";

export const IMAGECOUNT = "IMAGECOUNT";
export const TRANSACTIONLIST = "TRANSACTIONLIST";

export const REQUESTS = {
  ...createAction(LOGIN, "token", { loader: true }),
  ...createAction(LOGOUT, "token", {}),
  ...createAction(ISLOGGED, "token", {}),
  // ---  Do not update above code----
  ...createAction(DASHBOARD, "dashboard", {}),
  ...createAction(ROLE, "group", {}),
  ...createAction(ROLEALL, "group", {}),
  ...createAction(USERROLE, "user/group", {}),
  ...createAction(PERMISSION, "permission", {}),
  ...createAction(SETTINGS, "settings", {}),
  ...createAction(FORGOT, "public/forgotpassword", {}),
  ...createAction(USER, "user", {}),
  ...createAction(USERALL, "user", {}),

  ...createAction(COMPANY, "company", {}),
  ...createAction(COMPANYALL, "company", {}),
  ...createAction(PROJECT, "project", {}),
  ...createAction(PROJECTALL, "project", {}),
  ...createAction(TIMELAPSE, "timelapse", {}),
  ...createAction(TIMELAPSEALL, "timelapse", {}),
  ...createAction(LIVECAM, "livecam", {}),
  ...createAction(LIVECAMALL, "livecam", {}),
  ...createAction(PTZ, "all/payments", {}),
  ...createAction(PTZACTION, "ptzaction", {}),
  ...createAction(PTZACTIONALL, "ptzaction", {}),
  ...createAction(PACKAGE, "package", {}),
  ...createAction(PACKAGEALL, "package", {}),
  ...createAction(LATESTFILE, "latest", {}),
  ...createAction(BRAND, "camerabrand", {}),
  ...createAction(BRANDALL, "camerabrand", {}),
  ...createAction(PRESET, "preset", {}),
  ...createAction(PRESETALL, "preset", {}),
  ...createAction(TLVIDEO, "tlvideo", {}),
  ...createAction(TLVIDEOALL, "tlvideo", {}),
  ...createAction(IMGARCHIVE, "zip", {}),
  ...createAction(IMGARCHIVEALL, "zip", {}),
  ...createAction(VDOARCHIVE, "video", {}),
  ...createAction(LIVESETTINGS, "livesettings", {}),
  ...createAction(LIVESETTINGSALL, "livesettings", {}),
  ...createAction(LIVESETTINGSALL, "livesettings", {}),
  ...createAction(VIDEO, "video", {}),
  ...createAction(VIDEOALL, "video", {}),
  ...createAction(VIDEOZIP, "video-zip", {}),
  ...createAction(VIDEOZIPALL, "video-zip", {}),

  ...createAction(SENDEMAIL, "send-image-mail", {}),
  ...createAction(DATEDIMAGE, "datedlatest", {}),
  ...createAction(IMAGECOUNT, "image_count", {}),
  ...createAction(TRANSACTIONLIST, "transactions", {}),
};
